import { useDispatch, useSelector } from 'react-redux';
import AiImportMenuView from 'components/ImportMenu/AiImportMenuView';
import {
  importMenuFromJson,
  emptyPosMenu,
} from '../../../redux/actions/posMenu';

const BREAK_GLASS_PAGE = 'pos-menu-import';
const EMPTY_ACTION_SUMMARY = 'Empty POS menu for this business';

const PosMenuAiImport = () => {
  const dispatch = useDispatch();
  const businessUuid = useSelector(
    ({ business }) => business.currentBusiness?.uuid
  );

  return (
    <AiImportMenuView
      businessUuid={businessUuid}
      target="pos"
      breakGlassPage={BREAK_GLASS_PAGE}
      breakGlassEventType="pos-menu-import-action"
      emptyActionSummary={EMPTY_ACTION_SUMMARY}
      onImport={(menu) => dispatch(importMenuFromJson(businessUuid, menu))}
      onEmpty={() => dispatch(emptyPosMenu(businessUuid))}
    />
  );
};

export default PosMenuAiImport;
